import { create } from 'zustand'

import { ABIDescription } from '@remixproject/plugin-api';


export type ContractData = {
    name: string,
    address: string,
    abi: ABIDescription[]
}

type State = {
    deployedContracts: ContractData[]
}

type Action = {
    addDeployedContract: (newDeployedContract: ContractData) => void,
    removeDeployedContract: (contractIdx: number) => void,
}

const initialState: State = {
    deployedContracts: []
}

export const useDeployedContractStore = create<State & Action>()((set) => ({
    ...initialState,
    addDeployedContract: (newDeployedContract) => {
        set((state) => ({ deployedContracts: [...state.deployedContracts, newDeployedContract] }))
    },
    removeDeployedContract: (contractIdx: number) => {
        set((state) => ({ deployedContracts: [...state.deployedContracts.slice(0, contractIdx), ...state.deployedContracts.slice(contractIdx + 1, undefined)] }))
    }
}))